import AbstractPage from './AbstractPage';

export default class Contact extends AbstractPage {
    init() {
        this.callPrivacy();
        this.closeLightBox();

        this.modal.classList.add('gallery-container');
        this.modal.innerHTML = `<div class="gallery-container__back"></div><div class="gallery-container__close"></div><div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>`;
        document.body.appendChild(this.modal);
    }

    declareProperties() {
        this.button = document.querySelector('.ginput_container_consent a');
        this.modal = document.createElement('div');

        this.loaded = false;
    }

    callPrivacy() {
        this.button.addEventListener('click', e => {
            e.preventDefault();

            this.modal.classList.add('show');

            if (this.loaded) return;

            let XHR = new XMLHttpRequest();
            XHR.addEventListener('load', () => {
                let data = JSON.parse(XHR.responseText);
                this.modal.innerHTML += `<div class="gallery-container__content"><div class="content"><h1>${data.title.rendered}</h1>${data.content.rendered}</div></div>`;
                this.loaded = true;
            });

            XHR.addEventListener('error', () => {
                alert('Error getting privacy policy content');
            });

            XHR.open('GET', globalVars.siteUrl + '/wp-json/wp/v2/pages/3');
            XHR.send();

        })
    }

    closeLightBox() {
        document.addEventListener('click', e => {
            if (e.target && (e.target.classList.contains('gallery-container__close') || e.target.classList.contains('gallery-container__back'))) {
                this.modal.classList.remove('show');
            }
        });
    }
}
